import PropTypes from 'prop-types'
import { Box, TextField, Typography } from '@mui/material'

import ServiceRadioButtons from '../../../ui/modules/ServiceRadioButtons'

import { makeFormPropTypes } from '../../../common/formikPropTypes'
import { shippingSendMobilePropTypes } from '../../../common/propTypes'
import { getFieldProps, getErrorProp } from '../../../common/formProps'
import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'

const ContactAndShippingInfo = ({
  serviceTypeOptions,
  values,
  fieldErrors,
  touched,
  onBlur,
  onChangeValue,
}) => {
  const t = useTranslations()

  return (
    <>
      <Box sx={styles.contactAndShippingInfo}>
        <Typography variant="h2" sx={styles.contactAndShippingInfoTitle}>
          {t('shipping-send-form:shipment:information')}
        </Typography>
        <Typography variant="h4" sx={styles.contactAndShippingInfoSubtitle}>
          {t('noun:enter-size-and-aprox-weight')}
        </Typography>
        <Box sx={styles.contactAndShippingInfoPackagesInfoWrapper}>
          <TextField
            name="packagesNumber"
            id="packagesNumber"
            label={t('noun:number-of-packages')}
            type="number"
            {...getFieldProps(
              'packagesNumber',
              values,
              fieldErrors,
              touched,
              t,
            )}
            onChange={e =>
              onChangeValue({ name: 'packagesNumber', value: e.target.value })
            }
            onBlur={onBlur}
            sx={styles.textField}
            className="input-full"
            InputLabelProps={{ required: true }}
          />
          <TextField
            name="weight"
            id="weight"
            label={t('noun:total-weight-kgs')}
            type="number"
            {...getFieldProps('weight', values, fieldErrors, touched, t)}
            onChange={e =>
              onChangeValue({ name: 'weight', value: e.target.value })
            }
            onBlur={onBlur}
            sx={styles.textField}
            className="input-full"
            InputLabelProps={{ required: true }}
          />
        </Box>
        <Typography variant="h4" sx={styles.contactAndShippingInfoSubtitle}>
          {t('shipping-send-form:shipment:service-type')}
        </Typography>
        <Typography sx={styles.serviceType}>
          {t('shipping-send-form:shipment:fill-packages')}
        </Typography>
        <Box sx={{ mb: 3 }}>
          <ServiceRadioButtons
            id="serviceType"
            serviceTypeOptions={serviceTypeOptions}
            selectedService={values.serviceType}
            onChangeService={value =>
              onChangeValue({ name: 'serviceType', value })
            }
            {...getFieldProps('serviceType', values, fieldErrors, touched, t)}
            error={getErrorProp('serviceType', fieldErrors, touched)}
          />
        </Box>
        <TextField
          name="referenceNumber"
          id="referenceNumber"
          label={t('noun:clientReference')}
          type="text"
          {...getFieldProps('referenceNumber', values, fieldErrors, touched, t)}
          onChange={e =>
            onChangeValue({ name: 'referenceNumber', value: e.target.value })
          }
          onBlur={onBlur}
          className="input-full"
          sx={styles.textField}
          helperText={t('shipping-send-form:shipment:own-reference-number')}
        />
      </Box>
    </>
  )
}

ContactAndShippingInfo.propTypes = {
  serviceTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  onChangeValue: PropTypes.func,
  ...makeFormPropTypes(shippingSendMobilePropTypes),
}

export default ContactAndShippingInfo
